














import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { DragKinds } from "../../../../../../base/components/dragging";
import { IFormatObjectEditable } from "../../../../../domain/editableFormat";
import { ObjectsRelocator, RectangleCoordinatableObjectsTransformer, VectorCoordinatableObjectTransformer } from "./drag";
import { FormatPageMouseTrackableMixin } from "./mixins";

type Keys
  = "ObjectsRelocator"
  | "RectangleCoordinatableObjectsTransformer"
  | "VectorCoordinatableObjectTransformer";

interface IRequest {
  source: IFormatObjectEditable;
  event: PointerEvent;
  kind: DragKinds;
}

@Component({
  components: {
    ObjectsRelocator,
    RectangleCoordinatableObjectsTransformer,
    VectorCoordinatableObjectTransformer,
  }
})
export default class FormatPageObjectDragTracker extends Mixins(FormatPageMouseTrackableMixin) {
  data() {
    return {
      request: null as IRequest,
    };
  }

  request?: IRequest;

  get isDragging(): boolean {
    return !!this.key;
  }

  get key(): Keys {
    if (!this.request) {
      return null;
    }
    return Enumerable.from(Object.keys(FormatPageObjectDragTracker._trackers))
      .cast<Keys>()
      .firstOrDefault(k => 0 <= FormatPageObjectDragTracker._trackers[k].indexOf(this.request.kind));
  }

  drag(source: IFormatObjectEditable, event: PointerEvent, kind: DragKinds): void {
    this.request = {
      source,
      event,
      kind,
    };
  }

  onFinished(): void {
    this.request = null;
  }

  private static readonly _trackers: { [key in Keys]: DragKinds[] } = {
    ObjectsRelocator: [
      DragKinds.Self,
    ],
    RectangleCoordinatableObjectsTransformer: [
      DragKinds.TopLeft,
      DragKinds.TopRight,
      DragKinds.BottomLeft,
      DragKinds.BottomRight,
      DragKinds.Top,
      DragKinds.Bottom,
      DragKinds.Left,
      DragKinds.Right,
    ],
    VectorCoordinatableObjectTransformer: [
      DragKinds.From,
      DragKinds.To,
    ],
  };
}
